import { render, staticRenderFns } from "./PharmacySetting.vue?vue&type=template&id=544c2726&"
import script from "./PharmacySetting.vue?vue&type=script&lang=js&"
export * from "./PharmacySetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports